/**
 * ProductLightbox — galerie plein écran pour les pages produit.
 * Navigation: flèches clavier, swipe tactile, boutons, clic overlay/Échap pour fermer.
 */
(function () {
  'use strict';

  function ProductLightbox(images) {
    this.images = Array.isArray(images) ? images : [];
    this.currentIndex = 0;
    this.isOpen = false;

    this.touchStartX = 0;
    this.touchStartY = 0;
    this.SWIPE_THRESHOLD = 50;
    this.CLOSE_SWIPE_THRESHOLD = 100;

    this._lastFocusedEl = null;
    this._onKeydown = this._onKeydown.bind(this);
    this._onTouchStart = this._onTouchStart.bind(this);
    this._onTouchEnd = this._onTouchEnd.bind(this);

    this._buildDOM();
  }

  ProductLightbox.prototype._buildDOM = function () {
    var modal = document.createElement('div');
    modal.className = 'plb-modal';
    modal.setAttribute('role', 'dialog');
    modal.setAttribute('aria-modal', 'true');
    modal.setAttribute('aria-hidden', 'true');
    modal.setAttribute('aria-label', 'Galerie image produit');
    modal.innerHTML =
      '<div class="plb-overlay" data-plb-close></div>' +
      '<button type="button" class="plb-close" aria-label="Fermer" data-plb-close>&times;</button>' +
      '<button type="button" class="plb-arrow plb-arrow-prev" aria-label="Image précédente">&#10094;</button>' +
      '<button type="button" class="plb-arrow plb-arrow-next" aria-label="Image suivante">&#10095;</button>' +
      '<div class="plb-stage">' +
        '<div class="plb-loader" aria-hidden="true"></div>' +
        '<img class="plb-image" src="" alt="" draggable="false">' +
      '</div>' +
      '<div class="plb-counter"><span class="plb-counter-current">1</span> / <span class="plb-counter-total">1</span></div>';

    document.body.appendChild(modal);

    this.modalEl = modal;
    this.stageEl = modal.querySelector('.plb-stage');
    this.imgEl = modal.querySelector('.plb-image');
    this.loaderEl = modal.querySelector('.plb-loader');
    this.counterCurrentEl = modal.querySelector('.plb-counter-current');
    this.counterTotalEl = modal.querySelector('.plb-counter-total');
    this.prevBtn = modal.querySelector('.plb-arrow-prev');
    this.nextBtn = modal.querySelector('.plb-arrow-next');

    var self = this;
    Array.prototype.forEach.call(modal.querySelectorAll('[data-plb-close]'), function (el) {
      el.addEventListener('click', function () { self.close(); });
    });
    this.prevBtn.addEventListener('click', function () { self.prev(); });
    this.nextBtn.addEventListener('click', function () { self.next(); });

    this.counterTotalEl.textContent = this.images.length;
    if (this.images.length <= 1) {
      this.prevBtn.style.display = 'none';
      this.nextBtn.style.display = 'none';
    }
  };

  ProductLightbox.prototype.open = function (index) {
    if (!this.images.length) return;
    this.currentIndex = Math.max(0, Math.min(index || 0, this.images.length - 1));
    this._lastFocusedEl = document.activeElement;
    this.isOpen = true;

    this.modalEl.classList.add('is-open');
    this.modalEl.setAttribute('aria-hidden', 'false');
    document.body.classList.add('plb-lock-scroll');

    this._render();
    this._preloadAdjacent();

    document.addEventListener('keydown', this._onKeydown);
    this.stageEl.addEventListener('touchstart', this._onTouchStart, { passive: true });
    this.stageEl.addEventListener('touchend', this._onTouchEnd);

    this.modalEl.querySelector('.plb-close').focus();
  };

  ProductLightbox.prototype.close = function () {
    if (!this.isOpen) return;
    this.isOpen = false;

    this.modalEl.classList.remove('is-open');
    this.modalEl.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('plb-lock-scroll');

    document.removeEventListener('keydown', this._onKeydown);
    this.stageEl.removeEventListener('touchstart', this._onTouchStart);
    this.stageEl.removeEventListener('touchend', this._onTouchEnd);

    if (this._lastFocusedEl && typeof this._lastFocusedEl.focus === 'function') {
      this._lastFocusedEl.focus();
    }
  };

  ProductLightbox.prototype.next = function () { this.goTo(this.currentIndex + 1); };
  ProductLightbox.prototype.prev = function () { this.goTo(this.currentIndex - 1); };

  ProductLightbox.prototype.goTo = function (index) {
    var total = this.images.length;
    if (!total) return;
    this.currentIndex = ((index % total) + total) % total;
    this._render();
    this._preloadAdjacent();
  };

  ProductLightbox.prototype._render = function () {
    var item = this.images[this.currentIndex];
    if (!item) return;
    var self = this;

    this.loaderEl.classList.add('is-visible');
    this.imgEl.classList.remove('is-loaded');

    var preload = new Image();
    preload.onload = function () {
      self.imgEl.src = item.src;
      self.imgEl.alt = item.alt || '';
      self.loaderEl.classList.remove('is-visible');
      self.imgEl.classList.add('is-loaded');
    };
    preload.onerror = function () {
      self.loaderEl.classList.remove('is-visible');
    };
    preload.src = item.src;

    this.counterCurrentEl.textContent = this.currentIndex + 1;
  };

  ProductLightbox.prototype._preloadAdjacent = function () {
    var total = this.images.length;
    if (total <= 1) return;
    var nextIndex = (this.currentIndex + 1) % total;
    var prevIndex = (this.currentIndex - 1 + total) % total;
    [nextIndex, prevIndex].forEach(function (i) {
      var img = new Image();
      img.src = this.images[i].src;
    }, this);
  };

  ProductLightbox.prototype._onKeydown = function (e) {
    if (e.key === 'Escape') { this.close(); }
    else if (e.key === 'ArrowRight') { this.next(); }
    else if (e.key === 'ArrowLeft') { this.prev(); }
  };

  ProductLightbox.prototype._onTouchStart = function (e) {
    var t = e.changedTouches[0];
    this.touchStartX = t.clientX;
    this.touchStartY = t.clientY;
  };

  ProductLightbox.prototype._onTouchEnd = function (e) {
    var t = e.changedTouches[0];
    var deltaX = t.clientX - this.touchStartX;
    var deltaY = t.clientY - this.touchStartY;

    if (Math.abs(deltaY) > Math.abs(deltaX) && deltaY > this.CLOSE_SWIPE_THRESHOLD) {
      this.close();
      return;
    }
    if (Math.abs(deltaX) > this.SWIPE_THRESHOLD) {
      if (deltaX < 0) { this.next(); } else { this.prev(); }
    }
  };

  window.ProductLightbox = ProductLightbox;

  function initProductGallery() {
    var dataEl = document.getElementById('ProductGalleryData');
    if (!dataEl) return;

    var images;
    try {
      images = JSON.parse(dataEl.textContent);
    } catch (err) {
      return;
    }
    if (!images || !images.length) return;

    var lightbox = new ProductLightbox(images);

    document.addEventListener('click', function (e) {
      var trigger = e.target.closest('[data-lightbox-index]');
      if (!trigger) return;
      var index = parseInt(trigger.getAttribute('data-lightbox-index'), 10) || 0;
      lightbox.open(index);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initProductGallery);
  } else {
    initProductGallery();
  }
})();
